import React, { Fragment, useState } from "react";
import "../styles/home.scss";
import CustomHelmet from "../component/reusable/Helmet";
import { home2, homeBanner } from "../assets/images";
import { GiNothingToSay } from "react-icons/gi";
import { BiLogoPlayStore } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/userContext";
import GptLayout from "../component/gptLayout";
import PricingSection from "../component/gptPages/PricingSection";

import { faqData } from "../static/arrays/faqs";

import why1 from "../images/whyChooseUs/why1.png";
import why2 from "../images/whyChooseUs/why2.png";
import why3 from "../images/whyChooseUs/why3.png";
import why6 from "../images/whyChooseUs/why6.png";
import why4 from "../images/whyChooseUs/why4.png";
import why5 from "../images/whyChooseUs/why5.png";
import TestimonialSlider from "../component/TestimonialSlider";
import Faqs from "../component/Faqs";

const Home = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const handleNavigate = () => {
    if (auth?.user?._id) {
      navigate("/chat");
    } else {
      navigate("/login", { state: "/chat" });
    }
  };

  // FAQ ANswer mobile
  const [openTestimonyIndex, setOpenTestimonyIndex] = useState(0);
  const showFaqAnswer = (index) => {
    setOpenTestimonyIndex(index);
  };

  const astroVanshFeatures = [
    {
      id: "family-centric-approach",
      image: why1,
      title: "Family-Centric Approach",
      description:
        "Luck and destiny don't operate in isolation — they flow through the entire family. At AstroVansh, we analyze the kundalis of all family members together to provide deeper, more accurate, and interconnected insights.",
    },
    {
      id: "vastu-numerology-astrology",
      image: why2,
      title: "Vastu + Numerology + Astrology",
      description:
        "AstroVansh blends Vedic Astrology, Vastu Shastra, Numerology, and Aura Scanning to offer you holistic, spiritually aligned, and highly effective guidance for life's important decisions.",
    },
    {
      id: "personal-astrologer",
      image: why3,
      title: "Your Personal Astrologer, Anytime",
      description:
        "Choose your personal astrologer for life — someone who understands your journey, builds a lasting bond with your family, and offers guidance that grows with you over time.",
    },
    {
      id: "verified-vedic-experts",
      image: why4,
      title: "Verified Vedic Experts",
      description:
        "Our panel consists of highly experienced Vedic astrologers who bring decades of deep practice, ethical wisdom, and a strong track record of accurate and meaningful guidance to every consultation.",
    },
    {
      id: "secure-confidential",
      image: why5,
      title: "Secure & Confidential",
      description:
        "We deeply value your trust and take your privacy seriously. All your consultations and personal data remain fully confidential and securely protected at all times.",
    },
    {
      id: "interactive-tools",
      image: why6,
      title: "Modern Tools, Ancient Wisdom",
      description:
        "AstroVansh offers interactive reports, live consultations, and personalized daily predictions — all in one place. Our clean, intuitive interface is thoughtfully designed to be accessible and easy to use for all age groups, from young learners to elderly family members.",
    },
  ];

  return (
    <Fragment>
      <CustomHelmet
        title="ASTRO-GPT: Your ASTRO Self Preparation Tool"
        description="ASTRO-GPT a free self-preparation tool."
      />
      <GptLayout>
        <div className="container">
          <section className="home_page">
            <section className="banner_section">
              <div className="left">
                <span>One Family, One Astrologer, One Vision.</span>
                <h2>
                  Your Family <strong>Astro – Trusted.</strong>
                  <br /> Personal. <strong>Generational.</strong>
                </h2>
                <p>
                  At AstroVansh, we go beyond one-time predictions. We believe
                  your destiny is deeply connected with your family's journey.
                  That’s why we bring you a personal family astrologer — someone
                  who knows your family, tracks your life stages, and{" "}
                  <span>prepares you in advance for the road ahead.</span>
                  <br />
                  <br />
                  Whether it's career choices, marriage timing, children's
                  growth, or financial decisions — AstroVansh is your spiritual
                  partner for every milestone.
                </p>

                <div className="btn_wrap">
                  <button className="go_btn" onClick={() => handleNavigate()}>
                    <GiNothingToSay /> Choose your family Astrologer.
                  </button>
                  <button className="app_btn">
                    <BiLogoPlayStore /> Download on Google Play
                  </button>
                </div>
              </div>
              <div className="right">
                <img src={homeBanner} alt="home-banner" />
              </div>
            </section>

            <section className="mentor_section">
              <div className="title">
                <h2>
                  AstroVansh: Your family astrologer for  {" "}
                  <strong> holistic & proactive guidance.</strong>
                </h2>
                <p>
                  AstroVansh is your personal family astrology platform that
                  offers proactive, holistic guidance by analyzing the destiny
                  of your entire family as one karmic unit.
                </p>
              </div>
              <img src={home2} alt="home2" />
            </section>

            <section className="why_choose_use">
              <div className="title">
                <h2>Why Choose Us</h2>
              </div>
              <div className="card_list">
                {astroVanshFeatures?.map((ele) => (
                  <div className="card" key={ele?.id}>
                    <img src={ele?.image} alt={ele?.id} />
                    <h5>{ele?.title}</h5>
                    <p>{ele?.description}</p>
                  </div>
                ))}
              </div>
            </section>

            <TestimonialSlider />

            <PricingSection />

            <Faqs />
            
          </section>
        </div>
      </GptLayout>
    </Fragment>
  );
};

export default Home;
